/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
export type AdminQueryListResponseAllOf = {
  /** @nullable */
  results?: QueryItem[] | null;
  resultsTotal: number;
  /** @nullable */
  filterZoneItemOptions?: QueryFilterZoneOption[] | null;
  /** @nullable */
  filterUserOptions?: QueryFilterUserOption[] | null;
  /** @nullable */
  stocktakeId?: number | null;
};

export type AdminQueryListResponse = ResponseBase & AdminQueryListResponseAllOf;

export interface AdminZoneCreateRequest {
  fromZoneCode: number;
  toZoneCode: number;
}

export type AdminZoneCreateResponseAllOf = {
  result: boolean;
  /** @nullable */
  existingZoneCodes?: ZoneCodeResult[] | null;
};

export type AdminZoneCreateResponse = ResponseBase & AdminZoneCreateResponseAllOf;

export type AdminZoneDeleteResponseAllOf = {
  result: boolean;
};

export type AdminZoneDeleteResponse = ResponseBase & AdminZoneDeleteResponseAllOf;

export type AdminZoneHoldZoneResponseAllOf = {
  result: boolean;
};

export type AdminZoneHoldZoneResponse = ResponseBase & AdminZoneHoldZoneResponseAllOf;

export type AdminZoneListResponseAllOf = {
  /** @nullable */
  results?: ZoneItem[] | null;
  resultsTotal: number;
  /** @nullable */
  stocktakeId?: number | null;
  /** @nullable */
  completedStocktakes?: CompletedStocktakeListItem[] | null;
  /** @nullable */
  overview?: ZoneOverviewSection[] | null;
};

export type AdminZoneListResponse = ResponseBase & AdminZoneListResponseAllOf;

export interface AllCategoriesResponse {
  categories: CategorySummary[];
}

export interface AvailabilityRecord {
  branch: number;
  stock_Code: number;
  retail_Stock_Balance: number;
  warehouse_Stock_Balance: number;
  min_Stock_Balance: number;
  max_Stock_Balance: number;
  on_Order_Purchases: number;
  /** @nullable */
  bandA_Sell?: string | null;
  /** @nullable */
  last_Sell_Date?: string | null;
  /** @nullable */
  supplier_Ref?: string | null;
  outer_Unit: number;
  /** @nullable */
  expected_GI_Date?: string | null;
  super_Department_ID: number;
  department_ID: number;
  group_ID: number;
  sub_Group_ID: number;
  /** @nullable */
  last_PO_Date?: string | null;
  /** @nullable */
  last_PO_No?: string | null;
  /** @nullable */
  account_No?: string | null;
  full_Desc: string;
}

export interface AvailabilityRecords {
  /** @nullable */
  records?: AvailabilityRecord[] | null;
}

export interface AvailabilityStockItem {
  stockCode: number;
  description: string;
  /** @nullable */
  sellingPrice?: number | null;
  quantityAvailable: number;
}

export type BasicResponseAllOf = {
  result: boolean;
};

export type BasicResponse = ResponseBase & BasicResponseAllOf;

export type CategoryAllOf = {
  /** @nullable */
  superDepartment?: number | null;
  /** @nullable */
  department?: number | null;
  /** @nullable */
  mainGroup?: number | null;
  /** @nullable */
  subGroup?: number | null;
  /** @nullable */
  minQuantity?: number | null;
};

export type Category = CategorySummary & CategoryAllOf;

export interface CategoryEnumerableResponse {
  /** @nullable */
  errorMessage?: string | null;
  /** @nullable */
  results?: Category[] | null;
}

export interface CategoryResponse {
  listName: string;
  stockItems: AvailabilityStockItem[];
}

export interface CategorySummary {
  /** @nullable */
  availabilityListId?: number | null;
  listName: string;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  imageUrl?: string | null;
  active: boolean;
}

export interface CompleteAvailabilityListImageUploadRequest {
  details: MultipartUploadDetails;
  eTags: string[];
  availabilityListId: number;
}

export interface CompletedStocktakeListItem {
  stocktakeId: number;
  /** @nullable */
  completedBy?: number | null;
  /** @nullable */
  completedByName?: string | null;
  /** @nullable */
  completedAt?: string | null;
  year: number;
  readonly stocktakeLabel: string;
}

export type CreateAdminStocktakeResponseAllOf = {
  result: boolean;
  /** @nullable */
  stocktakeId?: number | null;
};

export type CreateAdminStocktakeResponse = ResponseBase & CreateAdminStocktakeResponseAllOf;

export interface DeleteAvailabilityListImageRequest {
  availabilityListId: number;
}

/**
 * @nullable
 */
export type GetAdminStocktakeCompletableResponseAllOfStocktake = StocktakeItem | null;

export type GetAdminStocktakeCompletableResponseAllOf = {
  result: boolean;
  /** @nullable */
  stocktake?: GetAdminStocktakeCompletableResponseAllOfStocktake;
};

export type GetAdminStocktakeCompletableResponse = ResponseBase & GetAdminStocktakeCompletableResponseAllOf;

/**
 * @nullable
 */
export type GetAdminStocktakeReviewResponseAllOfStocktake = StocktakeReviewItem | null;

export type GetAdminStocktakeReviewResponseAllOf = {
  /** @nullable */
  stocktake?: GetAdminStocktakeReviewResponseAllOfStocktake;
  /** @nullable */
  s3Location?: string | null;
};

export type GetAdminStocktakeReviewResponse = ResponseBase & GetAdminStocktakeReviewResponseAllOf;

export interface GetAuthConfigResponse {
  azureScopes: string[];
  azureDiscoveryUrl: string;
  azureClientId: string;
}

export interface GetConfigResponse {
  openRetailUsername: string;
  openRetailPassword: string;
  openRetailStockLookupUrl: string;
}

export type ListQueryResultAllOf = {
  resultsTotal: number;
};

export type ListQueryResult = QueryItem & ListQueryResultAllOf;

export type ListZoneResultAllOf = {
  resultsTotal: number;
};

export type ListZoneResult = ZoneItem & ListZoneResultAllOf;

/**
 * @nullable
 */
export type MultiRetailAvailabilityLookupResponseAllOfResponse = AvailabilityRecords | null;

export type MultiRetailAvailabilityLookupResponseAllOf = {
  /** @nullable */
  response?: MultiRetailAvailabilityLookupResponseAllOfResponse;
};

export type MultiRetailAvailabilityLookupResponse = ResponseBase & MultiRetailAvailabilityLookupResponseAllOf;

export interface MultiRetailProductLookupResponse {
  response: string;
}

export interface MultipartUploadDetails {
  bucket: string;
  key: string;
  uploadId: string;
}

export interface QueryCreateRequest {
  /** @nullable */
  zoneItemId?: number | null;
  /** @nullable */
  zoneCode?: string | null;
  details: string;
}

export type QueryCreateResponseAllOf = {
  zoneItemQueryId: number;
};

export type QueryCreateResponse = ResponseBase & QueryCreateResponseAllOf;

export interface QueryFilterUserOption {
  userId: number;
  userName: string;
}

export interface QueryFilterZoneOption {
  zoneCode: string;
  zoneItemCode: string;
}

/**
 * @nullable
 */
export type QueryGetResponseAllOfResult = QueryItem | null;

/**
 * @nullable
 */
export type QueryGetResponseAllOfZoneItem = ZoneListItem | null;

export type QueryGetResponseAllOf = {
  /** @nullable */
  result?: QueryGetResponseAllOfResult;
  /** @nullable */
  userId?: number | null;
  /** @nullable */
  zoneItem?: QueryGetResponseAllOfZoneItem;
};

export type QueryGetResponse = ResponseBase & QueryGetResponseAllOf;

export interface QueryImageCompleteUploadRequest {
  zoneItemQueryId: number;
  eTags: string[];
  details: MultipartUploadDetails;
}

export interface QueryImageCompleteUploadResponse {
  result: boolean;
}

export interface QueryImageDeleteRequest {
  zoneItemQueryImageId: number;
}

export interface QueryImageDeleteResponse {
  result: boolean;
}

export interface QueryImageItem {
  zoneItemQueryImageId: number;
  zoneItemQueryId: number;
  s3Location: string;
}

export interface QueryImageListResponse {
  /** @nullable */
  results?: QueryImageItem[] | null;
}

export interface QueryImageStartUploadRequest {
  chunks: number;
  /** @nullable */
  zoneItemId?: number | null;
  /** @nullable */
  zoneCode?: string | null;
  contentType: string;
}

export interface QueryImageStartUploadResponse {
  urls: string[];
  details: MultipartUploadDetails;
}

export interface QueryItem {
  zoneItemQueryId: number;
  zoneId: number;
  zoneCode: string;
  /** @nullable */
  zoneItemId?: number | null;
  /** @nullable */
  zoneItemCode?: string | null;
  /** @nullable */
  zoneItemStocktakeId?: number | null;
  queriedAt: string;
  queriedBy: number;
  queriedByName: string;
  details: string;
  /** @nullable */
  resolvedAt?: string | null;
  /** @nullable */
  resolvedBy?: number | null;
  /** @nullable */
  resolvedDetails?: string | null;
  /** @nullable */
  claimedBy?: number | null;
  /** @nullable */
  claimedByName?: string | null;
}

export type QueryListResponseAllOf = {
  /** @nullable */
  results?: QueryItem[] | null;
};

export type QueryListResponse = ResponseBase & QueryListResponseAllOf;

export interface QueryUpdateClaimedRequest {
  zoneItemQueryId: number;
  userClaimed: boolean;
}

export type QueryUpdateClaimedResponseAllOf = {
  result: boolean;
};

export type QueryUpdateClaimedResponse = ResponseBase & QueryUpdateClaimedResponseAllOf;

export interface QueryUpdateRequest {
  zoneItemQueryId: number;
  details: string;
}

export interface QueryUpdateResolvedRequest {
  zoneItemQueryId: number;
  resolvedDetails: string;
  /** @nullable */
  zoneItemId?: number | null;
}

export type QueryUpdateResolvedResponseAllOf = {
  result: boolean;
};

export type QueryUpdateResolvedResponse = ResponseBase & QueryUpdateResolvedResponseAllOf;

export type QueryUpdateResponseAllOf = {
  result: boolean;
};

export type QueryUpdateResponse = ResponseBase & QueryUpdateResponseAllOf;

export interface ResponseBase {
  /** @nullable */
  errorMessage?: string | null;
}

export interface StartAvailabilityListImageUploadRequest {
  availabilityListId: number;
  contentType: string;
  fileExtension: string;
  chunks: number;
}

export interface StartAvailabilityListImageUploadResponse {
  urls: string[];
  details: MultipartUploadDetails;
}

export interface StocktakeItem {
  stocktakeId: number;
  status: string;
  year: number;
  startedBy: number;
  startedAt: string;
  /** @nullable */
  completedBy?: number | null;
  /** @nullable */
  completedAt?: string | null;
}

export type StocktakeReviewItemAllOf = {
  /** @nullable */
  totalItems?: number | null;
  /** @nullable */
  totalQueries?: number | null;
  /** @nullable */
  sumItemCounts?: number | null;
};

export type StocktakeReviewItem = StocktakeItem & StocktakeReviewItemAllOf;

export interface UpdateAdminStocktakeRequest {
  status: string;
}

export type UpdateAdminStocktakeResponseAllOf = {
  result: boolean;
};

export type UpdateAdminStocktakeResponse = ResponseBase & UpdateAdminStocktakeResponseAllOf;

export interface UserDeviceCreateRequest {
  token: string;
  platform: string;
  tokenType: string;
}

export type UserDeviceCreateResponseAllOf = {
  result: boolean;
};

export type UserDeviceCreateResponse = ResponseBase & UserDeviceCreateResponseAllOf;

export type UserDeviceDeleteResponseAllOf = {
  result: boolean;
};

export type UserDeviceDeleteResponse = ResponseBase & UserDeviceDeleteResponseAllOf;

export interface UserDeviceItem {
  userDeviceId: number;
  userId: number;
  token: string;
  platform: string;
  tokenType: string;
}

export type UserDeviceListResponseAllOf = {
  /** @nullable */
  results?: UserDeviceItem[] | null;
};

export type UserDeviceListResponse = ResponseBase & UserDeviceListResponseAllOf;

export interface UserDeviceUpdateRequest {
  userDeviceId: number;
  token: string;
}

export type UserDeviceUpdateResponseAllOf = {
  result: boolean;
};

export type UserDeviceUpdateResponse = ResponseBase & UserDeviceUpdateResponseAllOf;

export interface UserNotificationItem {
  userNotificationId: number;
  userId: number;
  title: string;
  /** @nullable */
  body?: string | null;
  notifiedAt: string;
  /** @nullable */
  readAt?: string | null;
  /** @nullable */
  topic?: string | null;
  /** @nullable */
  zoneId?: number | null;
  /** @nullable */
  zoneCode?: string | null;
  /** @nullable */
  zoneItemId?: number | null;
  /** @nullable */
  zoneItemQueryId?: number | null;
}

export type UserNotificationListResponseAllOf = {
  /** @nullable */
  results?: UserNotificationItem[] | null;
};

export type UserNotificationListResponse = ResponseBase & UserNotificationListResponseAllOf;

export interface UserNotificationTopicCreateRequest {
  topic: string;
  active: boolean;
}

export type UserNotificationTopicCreateResponseAllOf = {
  result: boolean;
};

export type UserNotificationTopicCreateResponse = ResponseBase & UserNotificationTopicCreateResponseAllOf;

export type UserNotificationTopicDeleteResponseAllOf = {
  result: boolean;
};

export type UserNotificationTopicDeleteResponse = ResponseBase & UserNotificationTopicDeleteResponseAllOf;

export interface UserNotificationTopicItem {
  userNotificationTopicId: number;
  userId: number;
  topic: string;
  active: boolean;
}

export type UserNotificationTopicListResponseAllOf = {
  /** @nullable */
  results?: UserNotificationTopicItem[] | null;
};

export type UserNotificationTopicListResponse = ResponseBase & UserNotificationTopicListResponseAllOf;

export interface UserNotificationTopicUpdateRequest {
  userNotificationTopicId: number;
  active: boolean;
}

export type UserNotificationTopicUpdateResponseAllOf = {
  result: boolean;
};

export type UserNotificationTopicUpdateResponse = ResponseBase & UserNotificationTopicUpdateResponseAllOf;

export interface UserNotificationUpdateRequest {
  userNotificationId: number;
  readAt: string;
}

export type UserNotificationUpdateResponseAllOf = {
  result: boolean;
};

export type UserNotificationUpdateResponse = ResponseBase & UserNotificationUpdateResponseAllOf;

export interface ZoneCodeResult {
  code: string;
}

/**
 * @nullable
 */
export type ZoneGetResponseAllOfResult = ZoneItem | null;

export type ZoneGetResponseAllOf = {
  /** @nullable */
  result?: ZoneGetResponseAllOfResult;
  startedByRequestor: boolean;
  downloadItemsUrl: string;
};

export type ZoneGetResponse = ResponseBase & ZoneGetResponseAllOf;

export interface ZoneItem {
  stocktakeId: number;
  zoneId: number;
  code: string;
  status: ZoneItemStatus;
  queryCount: number;
  /** @nullable */
  startedAt?: string | null;
  /** @nullable */
  startedBy?: number | null;
  /** @nullable */
  startedByName?: string | null;
  /** @nullable */
  heldBy?: number | null;
  /** @nullable */
  heldByName?: string | null;
  readonly isHeld: boolean;
  isHeldByMe: boolean;
}

export interface ZoneItemCreateRequest {
  zoneId: number;
  code: string;
  count: number;
  scannedAt: string;
  /** @nullable */
  retailStockCode?: number | null;
  /** @nullable */
  retailDescription?: string | null;
  /** @nullable */
  retailStockBalance?: number | null;
  /** @nullable */
  retailPrice?: string | null;
}

export interface ZoneItemCreateResponse {
  zoneItemId: number;
  /** @nullable */
  errorMessage?: string | null;
}

export interface ZoneItemDeleteResponse {
  result: boolean;
}

/**
 * @nullable
 */
export type ZoneItemGetResponseResult = ZoneListItem | null;

export interface ZoneItemGetResponse {
  /** @nullable */
  result?: ZoneItemGetResponseResult;
  /** @nullable */
  errorMessage?: string | null;
}

export interface ZoneItemListResponse {
  /** @nullable */
  results?: ZoneListItem[] | null;
  /** @nullable */
  errorMessage?: string | null;
}

export type ZoneItemStatus = typeof ZoneItemStatus[keyof typeof ZoneItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZoneItemStatus = {
  WaitingToStart: 'WaitingToStart',
  Started: 'Started',
  Complete: 'Complete',
  Approved: 'Approved',
  OnHold: 'OnHold',
} as const;

export interface ZoneItemUpdateRequest {
  zoneItemId: number;
  code: string;
  count: number;
  /** @nullable */
  retailStockCode?: number | null;
  /** @nullable */
  retailDescription?: string | null;
  /** @nullable */
  retailStockBalance?: number | null;
  /** @nullable */
  retailPrice?: string | null;
}

export interface ZoneItemUpdateResponse {
  result: boolean;
}

export interface ZoneListItem {
  zoneStocktakeId: number;
  zoneItemId: number;
  zoneId: number;
  zoneCode: string;
  code: string;
  count: number;
  scannedAt: string;
  scannedBy: number;
  /** @nullable */
  retailStockCode?: number | null;
  /** @nullable */
  retailDescription?: string | null;
  /** @nullable */
  retailStockBalance?: number | null;
  /** @nullable */
  retailPrice?: string | null;
  /** @nullable */
  scannedByUserName?: string | null;
}

/**
 * @nullable
 */
export type ZoneListResponseAllOfStocktake = StocktakeItem | null;

export type ZoneListResponseAllOf = {
  /** @nullable */
  results?: ZoneItem[] | null;
  /** @nullable */
  stocktake?: ZoneListResponseAllOfStocktake;
};

export type ZoneListResponse = ResponseBase & ZoneListResponseAllOf;

export interface ZoneOverviewSection {
  status: ZoneItemStatus;
  count: number;
}

export interface ZoneUpdateRequest {
  zoneCode: string;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  startedAt?: string | null;
  updateStartedBy: boolean;
}

export type ZoneUpdateResponseAllOf = {
  result: boolean;
};

export type ZoneUpdateResponse = ResponseBase & ZoneUpdateResponseAllOf;

export type AdminListQueriesParams = {
filterZone?: string;
filterItem?: string;
filterUser?: number;
filterStatus?: string;
pageFrom?: number;
pageSize?: number;
};

export type GetAdminStocktakeReviewParams = {
stocktakeId?: number;
};

export type AdminListZonesParams = {
filterStatus?: number;
filterQuery?: number;
pageFrom?: number;
pageSize?: number;
searchQuery?: string;
};

export type AdminDeleteZoneParams = {
zoneCode?: string;
};

export type AdminHoldZoneParams = {
zoneCode?: string;
releaseHold?: boolean;
};

export type CategoryDetailsParams = {
id?: number;
};

export type DeleteAvailabilityListParams = {
id?: number;
};

export type LookupBarcodeParams = {
checkStockCode?: boolean;
barcode?: string;
searchDescription?: string;
};

export type LookupAvailabilityParams = {
superDepartmentId?: number;
departmentId?: number;
groupId?: number;
subGroupId?: number;
};

export type ListQueriesParams = {
filterZone?: string;
};

export type GetQueryParams = {
zoneItemQueryId?: number;
};

export type ListQueryImagesParams = {
zoneItemQueryId?: number;
};

export type DeleteUserDeviceParams = {
userDeviceId?: number;
};

export type ListUserNotificationsParams = {
pageFrom?: number;
pageSize?: number;
};

export type DeleteUserNotificationTopicParams = {
userNotificationTopicId?: number;
};

export type GetZoneParams = {
zoneCode?: string;
};

export type ListZoneItemsParams = {
zoneCode?: string;
};

export type GetZoneItemParams = {
zoneItemId?: number;
};

export type DeleteZoneItemParams = {
zoneItemId?: number;
};

